import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTraveller(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M12 12C13.6543 12 15 10.6543 15 9C15 7.34571 13.6543 6 12 6C10.3457 6 9 7.34571 9 9C9 10.6543 10.3457 12 12 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 4C3 2.89543 3.89543 2 5 2H19C20.1046 2 21 2.89543 21 4V17C21 18.1046 20.1046 19 19 19H15.5L13.2 22.0667C12.6 22.8667 11.4 22.8667 10.8 22.0667L8.5 19H5C3.89543 19 3 18.1046 3 17V4ZM19 4H5V15.8647C6.67224 14.4199 10.0448 13.5 12 13.5C13.9552 13.5 17.3278 14.4199 19 15.8647V4Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
